<template>
  <div class="w-full xl:max-w-209">
    <div class="flex w-full p-3 px-4 mb-8 bg-4y-lightsky-blue text-4y-nightsky-blue">
      <div v-if="variant !== 'none'" class="flex-shrink-0 w-8 xl:w-8 p-0.5 pr-2 -mt-0.5 text-4y-darksky-blue">
        <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 24 24" v-bind:svg-inline="''" v-bind:aria-hidden="'true'" v-bind:role="'presentation'" v-bind:focusable="'false'" v-bind:tabindex="'-1'"><path fill="currentColor" d="M12 4a8 8 0 100 16 8 8 0 000-16m1 13h-2v-6h2zm-1-7.75a1.25 1.25 0 110-2.5 1.25 1.25 0 010 2.5"/></svg>
      </div>
      <div >
        <p class="pb-2 font-bold leading-tight xl:text-lg text-4y-darksky-blue">
          {{ title }}
        </p>
        <p class="text-sm" v-html="message" />
      </div>
    </div>
  </div>
</template>

<script>
import Alert from '~brand-components/base/alert/alert'

export default Alert.extend()
</script>
